export enum Languages {
  CN = 'zh',
  TW = 'tw',
  JA = 'jp',
  EN = 'en'
}